import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
// import { CompsApiResponse } from "../comps-page.model";
import {
  VAIconRegistryService,
  close,
  check,
  plus,
} from "@va/core-library/icons";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-line-item-modal",
  templateUrl: "./line-item-modal.component.html",
  styleUrls: ["./line-item-modal.component.scss"],
})
export class LineItemModalComponent implements OnInit {
  @Input() addColTableData: Array<any>;
  @Input() stdLineItems: Array<any>;
  @Input() tickers: Array<string>;
  @Input() max: number;
  @Input() maxHeight: string;
  @Input() createSource;
  @Input() selectedPeriod: any;
  @Input() lineItemInputId = "compsLiModalLineItemInput";
  @Output() updateComp = new EventEmitter();
  @Input() isLIMModal = false;
  @Input() marketItemsData;
  @Input() ratioDenomData;
  @Input() showDenomCheckbox = true;
  @Input() disabled = false;
  @Input() placeholder = "Search Line Items";
  selectedRatioDenomItems;
  watchlisNameInput = "";
  selectedTickers: Array<any> = [];
  recentlyVisited: Array<any> = [];
  rightHeader: string;
  modalData: Array<any> = [];
  legacyUrl = `${window.caUrl}/app`;
  visible: boolean;
  selectedMenuItem = "";
  lineItems: Array<any> = [];
  selectedId = [];
  allItems: Array<any> = [];
  isLoading = false;
  fullVersion: string;
  version: number;
  showAdditionalColumns = true;
  openedForAddin = false;

  constructor(
    private appService: AppService,
    protected route: ActivatedRoute,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([close, check, plus]);
  }

  ngOnInit() {
    this.setModalData();
    this.addinVersionCheck();
    if (this.openedForAddin) {
      this.showAdditionalColumns = this.version > 22204;
    }
  }

  addinVersionCheck(): void {
    const url = this.route.snapshot.queryParams.redirectto || null;
    if (url) {
      const pattern = /([^v]*)$/; // regex to match everyhting after the last 'v'
      const addin = /clienttype=addin/; // check whether it was called from excel addin
      this.fullVersion = url.match(pattern)[0];
      this.version = Number(this.fullVersion.split(".")[2]);
      this.openedForAddin = addin.test(url);
    }
  }
  setModalData() {
    this.modalData = [...this.addColTableData];
    this.selectedId = [];
    this.rightHeader = `Selected Line Items (up to ${this.max}):`;
    //if (this.userTabId) {
    this.selectedMenuItem = this.stdLineItems[0].tab_full_name;
    // this.recentlyVisited = res.data[0].tab_sli_data;
    for (let i = 0; i < this.stdLineItems.length; i++) {
      const items = Object.assign({}, this.stdLineItems[i]);
      this.stdLineItems[i].tab_sli_data.map((el, index) => {
        let lineItem = {};
        const addedColData = this.modalData.find((obj) => {
          const id = el.sli_id || el.uniquesliid;
          const isSelected = obj.sli_id === id || obj.uniquesliid === id;
          if (isSelected) {
            obj["line_count"] = el.line_count
              ? `${el.line_count.toString()}`
              : null;
          }
          return isSelected;
        });
        if (addedColData) {
          addedColData.isSelected = true;
          items.tab_sli_data[index] = addedColData;
          this.selectedId = this.selectedId.concat(
            addedColData.sli_id || addedColData.uniquesliid,
          );
        } else {
          lineItem = {
            name: el.name,
            period: this.selectedPeriod
              ? this.selectedPeriod
              : [`CY-${new Date().getFullYear()}`],
            sli_comps_id: 0,
            sli_id: el.sli_id || el.uniquesliid,
            source: this.createSource,
            isSelected: false,
            line_count: el.line_count ? `${el.line_count.toString()}` : null,
            uniquesliid: el.sli_id || el.uniquesliid,
          };
          items.tab_sli_data[index] = lineItem;
        }
        // let obj = Object.assign({}, el);
        return el;
      });
      this.lineItems.push(items);
      //this.recentlyVisited[i]["isSelected"] = false;
    }
    this.recentlyVisited = this.lineItems[0].tab_sli_data;
    //}

    this.selectedRatioDenomItems = (this.ratioDenomData || [])
      .filter((item) => item.selected)
      .map((item) => item.name);
  }

  addSearchedTicker(tickerInfo): void {
    const company = {};
    company["ticker"] = tickerInfo.ticker;
    company["name"] = tickerInfo.full_name;
    company["isSelected"] = true;
    const tickerExist = this.modalData.filter((data) => {
      return data.ticker === tickerInfo.ticker;
    });
    if (tickerExist.length === 0) {
      this.modalData.push(company);
      this.updateComp.emit(this.modalData);
    }
  }

  addLi(params) {
    const tickerExist = this.modalData.filter((data) => {
      const id = params[0].sli_id || params[0].uniquesliid;
      return data.sli_id === id || data.uniquesliid === id;
    });
    if (tickerExist.length === 0) {
      const value =
        params[0].sliid || params[0].sli_id || params[0].uniquesliid;
      const selectedId = this.selectedId.concat(value) || [];
      this.selectedId = [...selectedId];
      for (let i = 0; i < this.lineItems.length; i++) {
        this.lineItems[i].tab_sli_data.map((el) => {
          const id = el.sli_id || el.uniquesliid;
          if (
            params[0].sliid === id ||
            params[0].sli_id === id ||
            params[0].uniquesliid === id
          ) {
            el.isSelected = true;
          }
          return el;
        });
      }
      params[0].isSelected = true;
      // const addedLIObj = {
      //   name: params[0].name,
      //   period: "CY-2020",
      //   sli_comps_id: params[0].sli_comps_id || 0,
      //   sli_id: params[0].sli_id,
      //   source: 'Concensus',
      //   isSelected: params[0].isSelected
      // }
      this.modalData.push(params[0]);
      this.updateComp.emit(this.modalData);
    }
  }

  onLiSelect(e, d) {
    this.selectedMenuItem = d.tab_full_name;
    this.recentlyVisited = d.tab_sli_data;
  }

  onMenuVisibleChange(visible) {
    this.visible = visible;
  }

  // selectTicker(e){
  //   debugger;
  //   console.log(e);
  //   if(e.currentTarget.classList.contains("selected-ticker-remove"))
  //     e.currentTarget.classList.remove("selected-ticker-remove");
  //   else
  //     e.currentTarget.classList.add("selected-ticker-remove");
  // }

  onLineitemChange(ev) {
    const data = { ...ev, parent: undefined };
    data.name = ev.label;
    let lineItem = {};
    lineItem = {
      ...data,
      name: data.label,
      period: this.selectedPeriod
        ? this.selectedPeriod
        : [`CY-${new Date().getFullYear()}`],
      sli_comps_id: 0,
      sli_id: data.id,
      source: this.createSource,
      isSelected: true,
    };
    let addedColData = [];
    let matched = false;
    for (let i = 0; i < this.lineItems.length; i++) {
      addedColData = this.lineItems[i].tab_sli_data.filter((obj) => {
        const id = data.id || data.sli_id || data.uniquesliid;
        const isSelected = obj.sli_id === id || obj.uniquesliid === id;
        if (isSelected) {
          obj.isSelected = true;
          matched = true;
        }
        return isSelected;
      });
      if (matched) {
        break;
      }
    }

    if (addedColData.length > 0) {
      this.addLi([lineItem, true]);
    }
  }

  removeLi(company) {
    this.selectedId = this.selectedId.filter((item) => item !== company.sli_id);
    // if(company.sli_comps_id){
    for (let i = 0; i < this.lineItems.length; i++) {
      this.lineItems[i].tab_sli_data.map((el) => {
        const id = el.id || el.sli_id || el.uniquesliid;
        const isSelected = company.sli_id === id || company.uniquesliid === id;
        if (isSelected) {
          el.isSelected = false;
        }
        return el;
      });
    }
    //}
    // else{
    //   company.isSelected = false;
    // }
    //company.isSelected = false;

    const index = this.modalData.indexOf(company);
    this.modalData.splice(index, 1);
    this.updateComp.emit(this.modalData);
  }

  addAllTickers() {
    const len = this.recentlyVisited.length;
    for (let i = 0; i < len; i++) {
      this.addLi([this.recentlyVisited[i], false]);
    }
    this.updateComp.emit(this.modalData);
  }

  removeAllTickers() {
    this.modalData = [];
    this.updateComp.emit(this.modalData);
    for (let i = 0; i < this.lineItems.length; i++) {
      this.lineItems[i].tab_sli_data.map((el) => {
        // let obj = Object.assign({}, el);
        el.isSelected = false;
        return el;
      });
    }
    this.selectedId = [];
  }

  /**
   * It executes on the change of denom checkbox change
   * It assigns the selected value to selectedRatioDenomItems
   * @param {object} value: selected denom item
   */
  handleRatioDenomItemValueChange(value) {
    this.selectedRatioDenomItems = value;
  }
}
